import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { MeBootstrap } from './components/MeBootstrap';
import { ActivatePage } from './pages/ActivatePage';
import { SetCredentialsPage } from './pages/SetCredentialsPage';
import { LoginPage } from './pages/LoginPage';
import { InvoicesPage } from './pages/InvoicesPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { DashboardPage } from './pages/DashboardPage';
import { ContextsPage } from './pages/ContextsPage';
import { Unavailable } from './components/Unavailable';
import { CustPortalErrorBoundary } from './components/ErrorBoundary';
import { DebugBanner } from './components/DebugBanner';
import { DebugPage } from './pages/DebugPage';

export default function PortalApp() {
	const isProd = process.env.NODE_ENV === 'production';
	const loc = useLocation();
	if (!isProd) {
		// eslint-disable-next-line no-console
		console.debug('[custportal] PortalApp location', loc.pathname);
	}
	return (
		<CustPortalErrorBoundary>
			<MeBootstrap>
				<Routes>
					<Route path="activate" element={<ActivatePage />} />
					<Route path="set-credentials" element={<SetCredentialsPage />} />
					<Route path="login" element={<LoginPage />} />
					<Route path="dashboard" element={<DashboardPage />} />
					<Route path="invoices" element={<InvoicesPage />} />
					<Route path="payments" element={<PaymentsPage />} />
					<Route path="contexts" element={<ContextsPage />} />
					<Route path="unavailable" element={<Unavailable />} />
					{!isProd && <Route path="debug" element={<DebugPage />} />}
					<Route index element={<Navigate to="login" replace />} />
					{!isProd && <Route path="*" element={<div style={{ padding: 16 }}>No portal route matched for: <strong>{loc.pathname}</strong></div>} />}
					{isProd && <Route path="*" element={<Navigate to="login" replace />} />}
				</Routes>
				{!isProd && <DebugBanner />}
			</MeBootstrap>
		</CustPortalErrorBoundary>
	);
} 